export const TOKEN_KEY = `esim-wholesale-token`;
export const REFRESH_TOKEN_KEY = `esim-wholesale-refresh-token`;
